module.exports = __webpack_public_path__ + "img/violet_042.338766b3.png";